module.exports = __webpack_public_path__ + "img/consultoria_3-4_1536.f6b0385c.jpg";